import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { formatDate, formatTime } from '../utils/booking';

const { FiArrowLeft, FiUsers } = FiIcons;

export default function WaitlistForm({ session, type, onBack, onSubmit }) {
  const [values, setValues] = useState({
    name: '',
    email: '',
    phone: '',
    party_size: 1,
    message: ''
  });
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  const update = ({ target }) => {
    setValues({
      ...values,
      [target.name]: target.name === 'party_size' ? Number(target.value) : target.value
    });
  };

  const submit = async (event) => {
    event.preventDefault();
    setSaving(true);
    const result = await onSubmit(values);
    setSaving(false);

    if (!result.ok) setError(result.error);
  };

  return (
    <form className="customer-form" onSubmit={submit}>
      <button type="button" className="back-link" onClick={onBack}>
        <SafeIcon icon={FiArrowLeft} /> Back to dates
      </button>
      <div className="selected-trip">
        <SafeIcon icon={FiUsers} />
        <span>
          <b>{type.name}</b>
          <small>{formatDate(session.date, true)} · {formatTime(session.start_time)}</small>
        </span>
      </div>
      <div className="demo-notice">
        <b>This trip is currently full.</b>
        <span>The guide will decide whom to contact if seats reopen.</span>
      </div>
      <label>
        Name
        <input name="name" value={values.name} onChange={update} required />
      </label>
      <div className="form-grid">
        <label>
          Email
          <input type="email" name="email" value={values.email} onChange={update} required />
        </label>
        <label>
          Phone
          <input type="tel" name="phone" value={values.phone} onChange={update} required />
        </label>
      </div>
      <label>
        Desired Party Size
        <select name="party_size" value={values.party_size} onChange={update}>
          {[1, 2, 3, 4, 5, 6].map((size) => <option key={size} value={size}>{size}</option>)}
        </select>
      </label>
      <label>
        Message for Guide
        <textarea name="message" rows="3" value={values.message} onChange={update} placeholder="Optional" />
      </label>
      {error && <div className="alert error">{error}</div>}
      <button className="button primary full" disabled={saving}>
        {saving ? 'Joining Waitlist…' : 'Join Waitlist'}
      </button>
    </form>
  );
}